import { useState, useEffect } from "react";

const useIsTablet = () => {
  const [isTablet, setIsTablet] = useState(
    window.matchMedia("(min-width: 601px) and (max-width: 1024px)").matches
  );

  useEffect(() => {
    const handleResize = () => {
      setIsTablet(
        window.matchMedia("(min-width: 601px) and (max-width: 1024px)").matches
      );
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isTablet;
};

export default useIsTablet;
